export * from './ngx-daterangepicker.component';
export * from './ngx-daterangepicker.module';
